import { Injectable } from '@angular/core';
import { DataTaskService } from '../core/services/data-task.service';
import { ErrorMessageResponse } from '@app/core/models/data-response';

@Injectable({
    providedIn: 'root',
})
export class TransportAreaService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 1399
     * @datataskName sp_ws_p2_w_transportarea_get
     * @param params the keyno of the transport area to get.
     * @returns promise containing the get.
     */
    public async getTransportArea(params: GetTransportAreaParams): Promise<TransportAreaGet> {
        return (await this.datatask.Post(1399, params))[0];
    }

    /**
     * @datatask 1400
     * @datataskName sp_ws_p2_w_transportarea_save
     * @param params the get to save.
     * @returns promise containing validation.
     */
    public async saveTransportArea(params: TransportAreaGet): Promise<SaveTransportAreaResponse> {
        return (await this.datatask.Post(1400, params))[0];
    }

    /**
     * @datatask 4056
     * @datataskName sp_ws_p2_transportarea_delete
     * @param params the get to delete.
     * @returns promise containing validation.
     */
    public async deleteTransportArea(params: TransportAreaGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(4056, params))[0];
    }

    /**
     * @datatask 1398
     * @datataskName sp_ws_p2_w_transportareamenu_get
     * @param params the keyno of the transport area menu to get.
     * @returns promise containing the get.
     */
    public async getTransportAreaMenu(params: GetTransportAreaMenuParams): Promise<TransportAreaMenuGet> {
        return (await this.datatask.Post(1398, params))[0];
    }

    /**
     * @datatask 1402
     * @datataskName sp_ws_p2_w_transportareappadd_get
     * @param params the keyno of the transport area.
     * @returns promise containing the page get.
     */
    public async getTransportAreaPostplacesAdd(params: GetTransportAreaPostplacesAddParams): Promise<TransportAreaPostplacesGet> {
        return (await this.datatask.Post(1402, params))[0];
    }

    /**
     * @datatask 4036
     * @datataskName tt_transportareappmove_get
     * @param params the keyno of the transport area.
     * @returns promise containing the page get.
     */
    public async getTransportAreaPostplacesMove(params: GetTransportAreaPostplacesMoveParams): Promise<TransportAreaPostplacesMoveGet> {
        return (await this.datatask.Post(4036, params))[0];
    }

    /**
     * @datatask 4037
     * @datataskName tt_transportareappmove_move
     * @param params the values of moving the selected postplaces..
     * @returns promise containing validation.
     */
    public async moveTransportAreaPostplaces(params: TransportAreaPostplacesMoveGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(4037, params))[0];
    }

    /**
     * @datatask 1403
     * @datataskName sp_ws_p2_w_transportareappadd_add
     * @param params the postplaces to add.
     * @returns promise containing validation.
     */
    public async addTransportAreaPostplaces(params: TransportAreaPostplacesGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(1403, params))[0];
    }

    /**
     * @datatask 1397
     * @datataskName sp_ws_p2_transportarea_list
     * @param params the id of the stockplace to retrieve transport areas for..
     * @return promise containing list of transport areas.
     */
    public getTransportAreaItems(params: GetTransportAreasParams): Promise<TransportAreaItem[]> {
        return this.datatask.Post(1397, params);
    }

    /**
     * @datatask 1404
     * @datataskName sp_ws_p2_transportareapp_list
     * @param params the keyno of the transport area menu to get.
     * @returns promise containing list of post places.
     */
    public getTransportAreaPostPlaces(params: GetTransportAreaMenuParams): Promise<TransportAreaPostPlaceItem[]> {
        return this.datatask.Post(1404, params);
    }
}

export interface GetTransportAreaParams {
    transportarea_keyno: string;
    stockplace_id: string;
}

export interface TransportAreaGet {
    transportarea_keyno: string;
    transportarea_name: string;
    stockplace_id: string;
    stockplace_name: string;
}

export interface SaveTransportAreaResponse extends ErrorMessageResponse {
    transportarea_keyno: string;
}

export interface GetTransportAreaMenuParams {
    transportarea_keyno: string | number;
    stockplace_id?: string;
}

export interface GetTransportAreaPostplacesAddParams {
    transportarea_keyno: string | number;
}

export interface TransportAreaPostplacesGet {
    postplace_id_fom: string;
    postplace_id_tom: string;
    transportarea_keyno: string;
    transportarea_name: string;
}

export interface TransportAreaMenuGet {
    transportarea_keyno: string;
    transportarea_name: string;
    stockplace_id: string;
    stockplace_name: string;
    filtervalue: string;
}

export interface GetTransportAreasParams {
    stockplace_id: string;

    /**
     * @default '0'
     */
    add_all?: '1' | '0';

    /**
     * @default '0'
     */
    add_unused_postplaces?: '1' | '0';
}

export interface TransportAreaItem {
    item_id: string;
    item_name: string;
    orderby: string;
    item_state: string;
    item_parms: string;
    item_path: string;
}

export interface TransportAreaPostPlaceItem {
    item_id: string;
    item_name: string;
    item_state: string;
    item_parms: string;
    item_path: string;
    orderby: string;
    item_filtervalue: string;
}

export interface GetTransportAreaPostplacesMoveParams {
    stockplace_id: string;
    transportarea_keyno: string;
}

export interface TransportAreaPostplacesMoveGet {
    transportarea_move_from_keyno: string;
    transportarea_move_from_name: string;
    transportarea_move_to_keyno: string;
}
